import React from 'react';
import { EditTwoTone } from '@ant-design/icons';

import './IconUpdate.less';

const IconUpdate = React.memo(({ style, ...rest }) => <EditTwoTone twoToneColor="#ff9900" {...rest} />);

export default IconUpdate;
